import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // 登录页面
  {
    path: '/',
    name: 'login',
    component: () => import('../views/login/login.vue')
  },
  // 项目申报富文本页面
  {
    path: '/rich',
    name: 'rich',
    component: () => import('../views/richText/index.vue')
  },
  // 项目申报表单页面
  {
    path: '/sign',
    name: 'sign',
    component: () => import('../views/signUp/index.vue')
  },
  // 成功页面
  {
    path: '/success',
    name: 'success',
    component: () => import('../views/success/index.vue')
  },
  //项目评审
  {
    path: '/xiangmu',
    name: 'xiangmu',
    component: () => import('../views/xiangmu/xiangmu.vue')
  },
  //注册页面
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/login/register.vue')
  },
  //个人信息
  {
    path: '/info',
    name: 'info',
    component: () => import('../views/richText/info.vue')
  },
  //手机号
  {
    path: '/phone',
    name: 'phone',
    component: () => import('../views/richText/phone.vue')
  },
  //密码
  {
    path: '/pass',
    name: 'pass',
    component: () => import('../views/richText/pass.vue')
  },
  //项目详情
  {
    path: '/project',
    name: 'project',
    component: () => import('../views/richText/project.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: '/shenbao',
  routes
})

export default router
